<template>
    <div id="FormSingleChoice">
        <div :class="`form-single-choice single-choice-align-${align}`">
            <label class="form-single-choice-title">{{ fieldLabel }}</label>
            <div>
                <div v-for="(option, index) in optionsRadio" :key="index" class="form-single-choice-option">
                    <input type="radio" :id="'option-' + index" name="singleChoice" :value="option"
                           v-model="selectedOptionRadio">
                    <label :for="'option-' + index">{{ option }}</label>
                    <button @click="removeOption(index)" class="remove-option">X</button>
                </div>

                <div class="form-single-choice-other-option">
                    <input type="text" v-model="localOtherOption" class="form-single-choice-other-input"
                           placeholder="Diğer" @input="updateField">
                    <button @click="saveOtherOption" class="form-single-choice-save-other">✔</button>
                    <button @click="discardOtherOption" class="form-single-choice-discard-other">✖</button>
                </div>

                <input type="text" v-model="newOption" class="form-single-choice-new-option"
                       placeholder="Bir seçenek yazın">
                <button @click="addOptionRadio" class="form-single-choice-add-button">Seçenek Ekle</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "SingleChoice",
    props: {
        fieldLabel: String,
        align: String,
        isRequired: Boolean,
        item: Object,
        otherOption: String,
    },
    data() {
        return {
            singleChoiceTitle: "Bir soru girin",
            optionsRadio: [],
            selectedOptionRadio: "",
            newOption: "",
            localOtherOption: this.otherOption || "",
            updateTimer: null,
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        addOptionRadio() {
            if (this.newOption.trim() !== "") {
                this.optionsRadio.push(this.newOption.trim());
                this.newOption = "";
                this.updateField();
            }
        },
        saveOtherOption() {
            if (this.localOtherOption.trim() !== "") {
                this.$message.success("Diğer seçenek kaydedildi.");
                this.updateField();
            }
        },
        discardOtherOption() {
            this.localOtherOption = "";
            this.$message.info("Diğer seçenek iptal edildi.");
            this.updateField();
        },
        removeOption(index) {
            this.optionsRadio.splice(index, 1);
            this.updateField();
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                const updateFields = {
                    singleChoice: {
                        fieldLabel: self.fieldLabel,
                        align: self.align,
                        isRequired: self.isRequired,
                        items: self.optionsRadio,
                        otherOption: self.localOtherOption,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
                self.$emit("update-field", updateFields);
            }, 200);
        },
    },
    watch: {
        item: {
            handler(newItem) {
                if (newItem && newItem.singleChoice) {
                    if (newItem.singleChoice.items) {
                        this.optionsRadio = newItem.singleChoice.items;
                    }
                    if (newItem.singleChoice.otherOption) {
                        this.localOtherOption = newItem.singleChoice.otherOption;
                    }
                }
            },
            immediate: true,
            deep: true,
        },
        otherOption: {
            handler(newValue) {
                this.localOtherOption = newValue;
            },
            immediate: true
        }
    },
    created() {
        this.updateField();
        if (this.item && this.item.singleChoice) {
            if (this.item.singleChoice.items) {
                this.optionsRadio = this.item.singleChoice.items;
            }
            if (this.item.singleChoice.otherOption) {
                this.localOtherOption = this.item.singleChoice.otherOption;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
#FormSingleChoice {
    .form-single-choice {
        margin: clamp(0.5rem, 1.5vw, 1rem) auto;
        padding: clamp(0.625rem, 1.5vw, 0.875rem);
        max-width: 700px;
        width: 100%;
        box-sizing: border-box;
        background: linear-gradient(145deg, 
            rgba(255, 255, 255, 0.02) 0%,
            rgba(255, 255, 255, 0.01) 100%);
        border-radius: 0.75rem;
        border: 1px solid rgba(255, 255, 255, 0.06);
        transition: all 0.3s ease;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

        &:hover {
            background: linear-gradient(145deg, 
                rgba(255, 255, 255, 0.03) 0%,
                rgba(255, 255, 255, 0.02) 100%);
        }

        .form-single-choice-title {
            display: block;
            font-size: clamp(0.95rem, 2.2vw, 1.1rem);
            font-weight: 600;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
            color: rgba(55, 65, 81, 0.9);
            border: none;
            padding: 0;
            width: 100%;
            background: transparent;
            outline: none;
            border-bottom: 2px solid transparent;
            transition: border-color 0.2s ease;

            &:focus {
                border-bottom-color: #f26a52;
            }
        }

        .form-single-choice-option {
            display: flex;
            align-items: center;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
            padding: clamp(0.375rem, 1vw, 0.5rem);
            background: rgba(255, 255, 255, 0.6);
            border: 1px solid rgba(226, 232, 240, 0.8);
            border-radius: 0.375rem;
            transition: all 0.2s ease;

            &:hover {
                background: rgba(255, 255, 255, 0.8);
                border-color: rgba(203, 213, 225, 0.8);
            }

            input[type="radio"] {
                margin-right: clamp(0.5rem, 1.2vw, 0.75rem);
                accent-color: #f26a52;
            }

            label {
                flex-grow: 1;
                margin-bottom: 0 !important;
                font-size: clamp(0.875rem, 1.8vw, 0.9rem);
                color: rgba(55, 65, 81, 0.9);
            }

            .remove-option {
                background: #ef4444;
                color: white;
                border: none;
                border-radius: 0.25rem;
                padding: clamp(0.25rem, 0.6vw, 0.375rem) clamp(0.375rem, 0.8vw, 0.5rem);
                cursor: pointer;
                font-size: clamp(0.75rem, 1.4vw, 0.8rem);
                transition: all 0.2s ease;

                &:hover {
                    background: #dc2626;
                    transform: scale(1.05);
                }
            }
        }

        .form-single-choice-new-option {
            width: 100%;
            min-width: 0;
            padding: clamp(0.5rem, 1.2vw, 0.75rem);
            border: 1px solid rgba(209, 213, 219, 0.6);
            border-radius: 0.375rem;
            font-size: clamp(0.875rem, 1.8vw, 0.9rem);
            background: rgba(255, 255, 255, 0.8);
            color: rgba(55, 65, 81, 0.9);
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
            backdrop-filter: blur(10px);
            transition: all 0.3s ease;
            font-family: inherit;
            box-sizing: border-box;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
                background: rgba(255, 255, 255, 0.95);
            }

            &::placeholder {
                color: rgba(107, 114, 128, 0.6);
            }
        }

        .form-single-choice-add-button {
            padding: clamp(0.5rem, 1.2vw, 0.625rem) clamp(0.75rem, 1.5vw, 1rem);
            background-color: #f26a52;
            color: white;
            border: none;
            border-radius: 0.375rem;
            font-size: clamp(0.8rem, 1.6vw, 0.875rem);
            font-weight: 500;
            cursor: pointer;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
            transition: all 0.2s ease;

            &:hover {
                background-color: #e55a42;
                transform: translateY(-1px);
                box-shadow: 0 2px 8px rgba(242, 106, 82, 0.3);
            }
        }

        .form-single-choice-other-option {
            display: flex;
            align-items: center;
            gap: clamp(0.375rem, 1vw, 0.5rem);
            margin-top: clamp(0.5rem, 1.2vw, 0.75rem);

            .form-single-choice-other-input {
                flex-grow: 1;
                min-width: 0;
                padding: clamp(0.5rem, 1.2vw, 0.75rem);
                border: 1px solid rgba(209, 213, 219, 0.6);
                border-radius: 0.375rem;
                font-size: clamp(0.875rem, 1.8vw, 0.9rem);
                background: rgba(255, 255, 255, 0.8);
                color: rgba(55, 65, 81, 0.9);
                font-family: inherit;
                transition: all 0.3s ease;
                box-sizing: border-box;

                &:focus {
                    outline: none;
                    border-color: #f26a52;
                    box-shadow: 0 0 0 2px rgba(242, 106, 82, 0.1);
                    background: rgba(255, 255, 255, 0.95);
                }
            }

            .form-single-choice-save-other,
            .form-single-choice-discard-other {
                background: none;
                border: none;
                font-size: clamp(1rem, 2vw, 1.125rem);
                cursor: pointer;
                padding: clamp(0.25rem, 0.6vw, 0.375rem);
                border-radius: 0.25rem;
                transition: all 0.2s ease;

                &:hover {
                    transform: scale(1.1);
                }
            }

            .form-single-choice-save-other {
                color: #10b981;
                &:hover {
                    background: rgba(16, 185, 129, 0.1);
                }
            }

            .form-single-choice-discard-other {
                color: #ef4444;
                &:hover {
                    background: rgba(239, 68, 68, 0.1);
                }
            }
        }
    }

    .single-choice-align-left,
    .single-choice-align-right {
        display: flex;
        align-items: flex-start;
        gap: clamp(0.75rem, 2vw, 1rem);

        .form-single-choice-title {
            min-width: clamp(80px, 15vw, 120px);
            max-width: clamp(120px, 25vw, 180px);
            flex-shrink: 0;
            margin-bottom: 0;
            padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
            word-wrap: break-word;
            hyphens: auto;
        }

        > div {
            flex: 1;
            min-width: 0; // Flexbox overflow fix
        }

        @media (max-width: 1024px) {
            .form-single-choice-title {
                min-width: clamp(70px, 12vw, 100px);
                max-width: clamp(100px, 20vw, 140px);
            }
        }

        @media (max-width: 768px) {
            flex-direction: column;
            gap: 0;
            
            .form-single-choice-title {
                min-width: auto;
                max-width: none;
                padding-top: 0;
                margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
                text-align: left;
            }

            > div {
                width: 100%;
            }
        }

        @media (max-width: 480px) {
            .form-single-choice-title {
                font-size: clamp(0.875rem, 2vw, 1rem);
            }
        }
    }

    .single-choice-align-right .form-single-choice-title {
        text-align: right;
    }

    .single-choice-align-left .form-single-choice-title {
        text-align: left;
    }
}
</style>
